import { NgModule } from '@angular/core';

import { MgPersonPipe } from './MgPerson.pipe';

@NgModule({
  declarations: [MgPersonPipe],
  exports: [MgPersonPipe],
})
export class MgPersonModule {}
